if (!customElements.get('ly-banner')) {
    customElements.define('ly-banner', class extends LyFullScrollCarousel {
        #initialized = false
        #initialDelayTimer = null
        #timer = null
        #scrollEndTimer = null
        #activePointers = new Set()
        #isHovered = false

        connectedCallback() {
            super.connectedCallback()

            this.#initialized = false
            this.#activePointers.clear()
            this.#isHovered = false

            const intervalSeconds = Number(this.dataset.interval || 5)

            if (!Number.isFinite(intervalSeconds) || intervalSeconds <= 0 || this._items.length <= 1) return

            this.interval = intervalSeconds * 1000

            this.#initialDelayTimer = setTimeout(() => {
                this.#initialDelayTimer = null
                this.#initialized = true
                this.startAutoPlay()
            }, 30_000)

            this.addEventListener('pointerdown', this.#handlePointerDown)
            window.addEventListener('pointerup', this.#handlePointerEnd)
            window.addEventListener('pointercancel', this.#handlePointerEnd)
            this.addEventListener('pointerenter', this.#handlePointerEnter)
            this.addEventListener('pointerleave', this.#handlePointerLeave)
            this._scroller.addEventListener('scroll', this.#handleScroll, { passive: true })
        }

        disconnectedCallback() {
            this.stopAutoPlay()
            clearTimeout(this.#initialDelayTimer)
            clearTimeout(this.#scrollEndTimer)

            this.#initialDelayTimer = null
            this.#scrollEndTimer = null
            this.#activePointers.clear()

            this.removeEventListener('pointerdown', this.#handlePointerDown)
            window.removeEventListener('pointerup', this.#handlePointerEnd)
            window.removeEventListener('pointercancel', this.#handlePointerEnd)
            this.removeEventListener('pointerenter', this.#handlePointerEnter)
            this.removeEventListener('pointerleave', this.#handlePointerLeave)
            this._scroller?.removeEventListener('scroll', this.#handleScroll)

            super.disconnectedCallback()
        }

        #handlePointerDown = evt => {
            this.#activePointers.add(evt.pointerId)
            clearTimeout(this.#scrollEndTimer)
            this.#scrollEndTimer = null
            this.stopAutoPlay()
            this._cancelProgrammaticScroll()
        }

        #handlePointerEnd = evt => {
            if (!this.#activePointers.delete(evt.pointerId)) return
            if (this.#activePointers.size > 0) return

            this.startAutoPlay()
        }

        #handlePointerEnter = evt => {
            if (evt.pointerType !== 'mouse') return

            this.#isHovered = true
            this.stopAutoPlay()
        }

        #handlePointerLeave = evt => {
            if (evt.pointerType !== 'mouse') return

            this.#isHovered = false

            if (this.#activePointers.size === 0) {
                this.startAutoPlay()
            }
        }

        #handleScroll = () => {
            this.stopAutoPlay()
            clearTimeout(this.#scrollEndTimer)

            this.#scrollEndTimer = setTimeout(() => {
                this.#scrollEndTimer = null
                this.startAutoPlay()
            }, 150)
        }

        _onScrollSettled = () => {
            this.startAutoPlay()
        }

        startAutoPlay = () => {
            if (!this.#initialized) return
            if (!Number.isFinite(this.interval) || this.interval <= 0) return
            if (this.#activePointers.size > 0 || this.#isHovered) return

            this.stopAutoPlay()

            this.#timer = setTimeout(() => {
                this.#timer = null
                this._index = (this._index + 1) % this._items.length
            }, this.interval)
        }

        stopAutoPlay = () => {
            clearTimeout(this.#timer)
            this.#timer = null
        }
    })
}
